module.exports = __webpack_public_path__ + "img/日常考试@3x.1bda3327.png";